import React from 'react';
import styles from './teamSubmission.module.scss';

export default class TeamSubmission extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div>
                <h1>Draft Links</h1>
                <div>
                    <h2><a href="http://doogiecup.com/clubs/uncontracted/2026">Uncontracted Stats</a></h2>
                </div>
                <div>
                    <h2>Current squads</h2>
                    <div><a href="http://doogiecup.com/clubs/8/2026">Boner</a></div>
                    <div><a href="http://doogiecup.com/clubs/4/2026">Cazzu Grandes</a></div>
                    <div><a href="http://doogiecup.com/clubs/3/2026">Cheats</a></div>
                    <div><a href="http://doogiecup.com/clubs/5/2026">Corio</a></div>
                    <div><a href="http://doogiecup.com/clubs/7/2026">Fitzroy</a></div>
                    <div><a href="http://doogiecup.com/clubs/11/2026">Flannie</a></div>
                    <div><a href="http://doogiecup.com/clubs/10/2026">Helpers</a></div>
                    <div><a href="http://doogiecup.com/clubs/6/2026">Phils</a></div>
                    <div><a href="http://doogiecup.com/clubs/9/2026">Pirates</a></div>
                    <div><a href="http://doogiecup.com/clubs/12/2026">Southside</a></div>
                    <div><a href="http://doogiecup.com/clubs/2/2026">Village</a></div>
                    <div><a href="http://doogiecup.com/clubs/1/2026">Walkabout</a></div>
                </div>
            </div>
        );
    }
}
